import { useState } from 'react'
import { Box, Text, CloseButton } from '@chakra-ui/react'
import { theme } from 'styles'

// Shown on both the internal search page and the shared client link. Those two
// views are near-duplicates, so this lives in one place rather than being
// pasted into both and drifting apart.
const STORAGE_KEY = 'paloma.searchLinkHintDismissed'

const SearchLinkHint = (props) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1'
    } catch (err) {
      // Private browsing and blocked storage both throw here; showing the hint
      // is the safe fallback.
      return false
    }
  })

  if (dismissed) { return null }

  const dismiss = () => {
    setDismissed(true)
    try { window.localStorage.setItem(STORAGE_KEY, '1') } catch (err) { /* not critical */ }
  }

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={3}
      px={4}
      py={3}
      bg={theme.greenTint}
      borderWidth="1px"
      borderColor={theme.line}
      borderRadius="10px"
      {...props}
    >
      <Text fontSize="14px" lineHeight="1.6" color={theme.text}>
        Click a talent&rsquo;s photo to open their full profile. To remove
        someone from this link, click <strong>Unselect</strong> on their card,
        then <strong>Save</strong>.
      </Text>
      <CloseButton
        size="sm"
        ml="auto"
        flex="none"
        color={theme.muted}
        aria-label="Dismiss this tip"
        onClick={dismiss}
        _hover={{ bg: 'transparent', color: theme.ink }}
      />
    </Box>
  )
}

export default SearchLinkHint
